'use client';

import * as React from 'react';
import { RootLink } from 'components/link/link';
import { useAtomValue } from 'jotai';
import { footerLinksAtom } from '../../../_components/design-state';

export function FooterLinks(): JSX.Element {
  const footerLinks = useAtomValue(footerLinksAtom);
  return (
    <>
      {footerLinks.map((link) => (
        <RootLink href={link.href} key={link.name}>
          {link.name}
        </RootLink>
      ))}
    </>
  );
}
